module.exports = __webpack_public_path__ + "img/emoji4.d5c8457b.svg";